// src/pages/AddSource.js
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Checkbox, message, Row, Col } from "antd";
import api from "../services/api";
import { categories, subs } from "../constants";
import RemoveTagsInput from "../components/RemoveTagsInput";
import RemoveAttrsInput from "../components/RemoveAttrsInput";
import AlertMessage from "../components/AlertMessage";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

export default function AddSource() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [removeTags, setRemoveTags] = useState([]);
  const [removeAttrs, setRemoveAttrs] = useState([]);
  const [filteredSubs, setFilteredSubs] = useState([]);
  const [alert, setAlert] = useState({ type: "", text: "" });

  // برای انتخاب منبع قبلی
  const [sources, setSources] = useState([]);
  const [selectedSourceId, setSelectedSourceId] = useState(null);

  useEffect(() => {
    if (!token) navigate("/dashboard/home");

    // گرفتن لیست سورس‌ها برای انتخاب
    const fetchSources = async () => {
      try {
        const res = await api.get("/sources/fuldistinct", { headers: { token } });
        setSources(res.data.sources || []);
      } catch (err) {
        console.error("خطا در گرفتن لیست منابع:", err);
      }
    };
    fetchSources();
  }, [token]);

  const parseSafe = (val) => {
    if (!val) return [];
    try {
      return typeof val === "string" ? JSON.parse(val) : val;
    } catch (e) {
      console.warn("JSON parse error:", e);
      return [];
    }
  };

  const handleCategoryChange = (value) => {
    const cat = categories.find((c) => c.categoryPr === value);
    if (!cat) return;
    form.setFieldsValue({
      categoryPr: cat.categoryPr,
      categoryEn: cat.categoryEn,
      categoryCode: cat.code,
      subCategoryPr: "",
      subCategoryEn: "",
    });
    const subsFiltered = subs.filter((s) => s.surCode === cat.code);
    setFilteredSubs(subsFiltered);
  };

  const handleSubCategoryChange = (value) => {
    const sub = subs.find((s) => s.subCategoryPr === value);
    if (!sub) return;
    form.setFieldsValue({
      subCategoryPr: sub.subCategoryPr,
      subCategoryEn: sub.subCategoryEn,
    });
  };

  const handleSourceSelect = (value) => {
    setSelectedSourceId(value);
    if (!value) {
      form.resetFields();
      setRemoveTags([]);
      setRemoveAttrs([]);
      return;
    }

    const selectedSource = sources.find((s) => s._id === value);
    if (selectedSource) {
      // پرکردن فرم به جز rssURL و دسته‌بندی‌ها
      form.setFieldsValue({
        sourceName: selectedSource.sourceName,
        sourceNameEn: selectedSource.sourceNameEn,
        siteAddress: selectedSource.siteAddress,
        tagClassName: selectedSource.tagClassName,
        secondTag: selectedSource.secondTag,
        cutAfter: selectedSource.cutAfter,
        isLocalImg: selectedSource.isLocalImg,
        isCategorized: selectedSource.isCategorized,
        isSubCategorized: selectedSource.isSubCategorized,
      });

      setRemoveTags(parseSafe(selectedSource.removeTags));
      setRemoveAttrs(parseSafe(selectedSource.removeAttrs));
    }
  };

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        isLocalImg: !!values.isLocalImg,
        isCategorized: !!values.isCategorized,
        isSubCategorized: !!values.isSubCategorized,
        removeTags: JSON.stringify(removeTags),
        removeAttrs: JSON.stringify(removeAttrs),
      };

      await api.post("/sources", payload, { headers: { token } });
      message.success("منبع با موفقیت اضافه شد");
      setAlert({ type: "success", text: "منبع با موفقیت اضافه شد" });
      setTimeout(() => navigate("/dashboard/sources"), 3000);
    } catch (err) {
      console.error("خطا:", err);
      setAlert({ type: "error", text: "خطا در اضافه کردن منبع" });
      setTimeout(() => setAlert({ type: "", text: "" }), 3000);
      const errorMsg =
        err.response?.data?.message || err.message || "خطا در اضافه کردن منبع";
      message.error(errorMsg);
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: "auto", padding: 16 }}>
      <h2>افزودن منبع جدید</h2>
      

      {/* انتخاب منبع قبلی */}
      <div style={{ marginBottom: 16 }}>
        <label>آیا می‌خواهید از منبع قبلی استفاده کنید؟</label>
        <Select
          style={{ width: "100%", marginTop: 8 }}
          placeholder="انتخاب منبع قبلی یا خالی گذاشتن برای منبع جدید"
          onChange={handleSourceSelect}
          allowClear
          value={selectedSourceId || undefined}
        >
          {sources.map((s) => (
            <Option key={s._id} value={s._id}>
              {s.sourceName}
            </Option>
          ))}
        </Select>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          isLocalImg: true,
          isCategorized: true,
          isSubCategorized: true,
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="sourceName"
              name="sourceName"
              rules={[{ required: true, message: "این فیلد الزامی است" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="sourceNameEn"
              name="sourceNameEn"
              rules={[{ required: true, message: "این فیلد الزامی است" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="siteAddress"
              name="siteAddress"
              rules={[{ required: true, message: "این فیلد الزامی است" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="rssURL"
              name="rssURL"
              rules={[{ required: true, message: "این فیلد الزامی است" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="tagClassName" name="tagClassName">
          <Input />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Form.Item name="isLocalImg" valuePropName="checked">
              <Checkbox>isLocalImg</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="secondTag">
              <Input placeholder="secondTag" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item label="Remove Tags">
              <RemoveTagsInput value={removeTags} onChange={setRemoveTags} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label="Remove Attributes">
              <RemoveAttrsInput value={removeAttrs} onChange={setRemoveAttrs} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="cutAfter" name="cutAfter">
          <Input />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Form.Item name="isCategorized" valuePropName="checked">
              <Checkbox>isCategorized</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Category" name="categoryPr">
              <Select
                placeholder="انتخاب دسته‌بندی"
                onChange={handleCategoryChange}
              >
                {categories.map((c) => (
                  <Option key={c.code} value={c.categoryPr}>
                    {c.categoryPr}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Form.Item name="isSubCategorized" valuePropName="checked">
              <Checkbox>isSubCategorized</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="SubCategory" name="subCategoryPr">
              <Select
                placeholder="انتخاب زیر دسته"
                onChange={handleSubCategoryChange}
              >
                {filteredSubs.map((s) => (
                  <Option key={s.code} value={s.subCategoryPr}>
                    {s.subCategoryPr}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <AlertMessage type={alert.type} text={alert.text} />
        <Row gutter={[16, 16]}>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              ذخیره منبع
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={() => navigate("/dashboard/sources")}
            >
              بازگشت به لیست منابع
            </Button>
          </Col>
        </Row>

        <Form.Item name="categoryEn" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="subCategoryEn" hidden>
          <Input />
        </Form.Item>
      </Form>
    </div>
  );
}
